import { useState, useEffect } from "react";
import { EuiButtonEmpty, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { isNullOrUndefined } from "utils";
import Popover from "../Popover/Popover";
import { ElipseIcon } from "components/Icons";

export default function FdDataTableRowActions({ Row, Buttons = [] }: any) {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [isNewTabIntent, setIsNewTabIntent] = useState<boolean>(false);
  const [hoverId, setHoverId] = useState<any>(null);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey) setIsNewTabIntent(true);
    };

    const up = () => setIsNewTabIntent(false);

    window.addEventListener("keydown", down);
    window.addEventListener("keyup", up);

    return () => {
      window.removeEventListener("keydown", down);
      window.removeEventListener("keyup", up);
    };
  }, []);

  const openButton = (
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="ellipsis-actions-button actions-button-hover"
      onClick={(e) => {
        e.stopPropagation();
        setIsPopoverOpen((state) => !state);
      }}>
      <ElipseIcon />
    </div>
  );

  return (
    <div>
      <Popover
        anchorPosition="downLeft"
        button={openButton}
        onClose={() => setIsPopoverOpen(false)}
        isOpen={isPopoverOpen}
        ownFocus={false}
        panelPaddingSize="xs"
        children={
          <EuiFlexGroup
            alignItems="flexStart"
            direction="column"
            gutterSize="none"
            responsive={false}>
            {Buttons.map((btn: any, index: number) => {
              const isVisible =
                typeof btn.isVisible === "function"
                  ? btn.isVisible(Row)
                  : isNullOrUndefined(btn.isVisible)
                    ? true
                    : btn.isVisible;

              return !isVisible ? (
                <></>
              ) : (
                <EuiFlexItem grow={false} key={`menu_button_${index}`}>
                  <EuiButtonEmpty
                    color="text"
                    iconType={
                      btn?.allowNewTab && isNewTabIntent && hoverId === index
                        ? "external"
                        : btn.icon
                    }
                    isDisabled={
                      typeof btn.isDisabled === "function"
                        ? btn.isDisabled(Row)
                        : isNullOrUndefined(btn.isDisabled)
                          ? false
                          : btn.isDisabled
                    }
                    onClick={(e: any) => {
                      e.stopPropagation();

                      const isNewTab = e.ctrlKey || e.metaKey || e.button === 1;
                      btn.onClick(Row, e, isNewTab);
                      setIsPopoverOpen(false);
                    }}
                    onMouseOver={() => {
                      setHoverId(index);
                    }}
                    onMouseLeave={() => {
                      setHoverId(null);
                    }}
                    size="s"
                    type="button"
                    {...(btn.buttonProps || {})}
                    data-test-subj={btn.name}>
                    {btn.name}
                  </EuiButtonEmpty>
                </EuiFlexItem>
              );
            })}
          </EuiFlexGroup>
        }
      />
    </div>
  );
}
